import CalendarIcon from 'vue-material-design-icons/CalendarRange.vue';
import PersonIcon from '@/shared/icons/PersonIcon.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import PhoneIcon from 'vue-material-design-icons/Phone.vue';
import TextIcon from 'vue-material-design-icons/TextShort.vue';
import DecimalIcon from 'vue-material-design-icons/CurrencyGbp.vue';
import CustomAttributeIcon from '@/shared/icons/CustomAttributeIcon.vue';
import QuestionIcon from 'vue-material-design-icons/ForumOutline.vue';
import NumberIcon from 'vue-material-design-icons/Pound.vue';
import PageIcon from 'vue-material-design-icons/Earth.vue';
import DurationIcon from 'vue-material-design-icons/ClockOutline.vue';
import MessageIcon from '@/shared/icons/MessageIcon.vue';
import ListIcon from '@/shared/icons/ListIcon.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import AnswerIcon from '@/shared/icons/AnswerIcon.vue';
import FlowVariableIcon from '@/shared/icons/FlowVariableIcon.vue';

export const Icons = {
  CalendarIcon,
  PersonIcon,
  EmailIcon,
  PhoneIcon,
  TextIcon,
  DecimalIcon,
  CustomAttributeIcon,
  QuestionIcon,
  NumberIcon,
  PageIcon,
  DurationIcon,
  MessageIcon,
  ListIcon,
  ErrorIcon,
  FlowIcon,
  AnswerIcon,
  FlowVariableIcon,
};

export type IconType = keyof typeof Icons;
